import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CircularProgress from '@mui/material/CircularProgress';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import {
  fetchOrbits, fetchCarsOptionsData, fetchUpdateTravel, fetchSadirTravel,
  fetchDeleteTravel, fetchPaymentDetailsRefund
} from '../../apiCall';
import { Link } from 'react-router-dom';
import Footer from '../Footer/Footer';
import '../editSadir/editSadir.css'




function EditSadir({ invitation, id }) {
  const [editMode, setEditMode] = useState(false);
  const [approv, setApprov] = useState(false);
  const [notApprov, setNotApprov] = useState(false);
  const [passenger, setPassenger] = useState({});
  const [orbitName] = useState({});
  const [allOrbits, setOrbits] = useState([]);
  const [carName] = useState({});
  const [carTypes, setCarTypes] = useState({});
  const [updateInvitation, setUpdateInvitation] = useState({});
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  // const currentDate = new Date();
  // const invitationDate = new Date(invitation.date);
  // const timeDifference = invitationDate.getTime() - currentDate.getTime();
  // const hoursDifference = Math.ceil(timeDifference / (1000 * 60 * 60));
  // const shouldShowDeleteBtn = hoursDifference > 24;


  useEffect(() => {
    getOrbits();
    getCarTypes();
    setUpdateInvitation(invitation);
    if (invitation.customerDetails === undefined) {
      setApprov(true)
      const passenger = invitation.passengers.find(
        (pass) => pass.connectedCustomerTravel === id
      );
      setPassenger(passenger)
    } else {
      setNotApprov(true)
    }
  }, []);

  const getOrbits = () => {
    fetchOrbits("sadir", function (response) {
      if (!response.result || response == null) {
      } else {
        setOrbits(response.result)
      }
    });
  };
  const getCarTypes = () => {
    fetchCarsOptionsData(function (response) {
      if (!response.result || response == null) {
      } else {
        setCarTypes(response.result)
      }
    });
  };

  const handleSaveEditInvitation = () => {
    setEditMode(false);
    setIsLoading(true);
    console.log(updateInvitation)
    if (invitation.passengers !== undefined) {
      fetchSadirTravel(invitation, function (response) {
      }).then(() => {
        setIsLoading(false);
        alert('ההזמנה נערכה בהצלחה')
      }).catch(() => {
        setIsLoading(false);
        alert('ארעה שגיאה בשמירת העריכה')
      });
    } else {
      invitation.id = id ; 
      fetchUpdateTravel(invitation, function (response) {
        console.log(invitation , "ffff")
      }).then(() => {
        setIsLoading(false);
        alert('ההזמנה נערכה בהצלחה')
      }).catch(() => {
        setIsLoading(false);
        alert('ארעה שגיאה בשמירת העריכה')
      });
    }
  }

  const handleCancelEditInvitation = () => {
    setEditMode(false);
  }

  const handleEditInvitation = () => {
    setEditMode(true);
  }

  const refund = () => {
    if (invitation.price) {
      fetchPaymentDetailsRefund((data) => {
        setShowIframe(true)
        if (data.URL) {
          const iframe = document.getElementById('iframeContainer');
          iframe.src = data.URL;
          iframe.setAttribute('allow', 'payment');
        }
      }, -invitation.price);
    } else {
      fetchPaymentDetailsRefund((data) => {
        setShowIframe(true)
        if (data.URL) {
          const iframe = document.getElementById('iframeContainer');
          iframe.src = data.URL;
          //iframe.sandbox = "allow-popups allow-same-origin"
          //iframe.name="sandbox"
          iframe.setAttribute('allow', 'payment');
        }
      }, -passenger.money.price);
    }
  }

  const handleDeleteInvitation = () => {
    console.log(invitation.price, passenger)
    const confirmDelete = window.confirm('האם למחוק את הנסיעה?');
    if (confirmDelete) {
      refund();

      console.log(passenger.connectedCustomerTravel)
      //   fetchDeleteCustomerTravel(passenger.connectedCustomerTravel, function(response){
      //   }).then(()=>{
      //     setShowError(true);
      //    alert('ההזמנה נמחקה בהצלחה')
      // }).catch(()=>{
      //    alert('ארעה שגיאה במחיקת הנסיעה')
      // });
      if (invitation.passengers !== undefined) {
        const passengerIndex = invitation.passengers.findIndex(
          (pass) => pass.id === passenger.id
        );

        if (passengerIndex !== -1) {
          invitation.passengers.splice(passengerIndex, 1);
        }
        fetchSadirTravel(invitation, function (response) {
          console.log(invitation)
        }).then(() => {
          fetchDeleteTravel(invitation, function (response) {
          }).then(() => {
            setShowError(true);
            alert('ההזמנה נמחקה בהצלחה')
          }).catch(() => {
            alert('ארעה שגיאה במחיקת הנסיעה')
          });
          alert('ההזמנה נמחקה בהצלחה')
        }).catch(() => {
          alert('ארעה שגיאה במחיקת הנסיעה')
        });
      } else {
        fetchDeleteTravel(invitation, function (response) {
        }).then(() => {
          setShowError(true);
          alert('ההזמנה נמחקה בהצלחה')
        }).catch(() => {
          alert('ארעה שגיאה במחיקת הנסיעה')
        });

      }
    }

  }

  const shouldDisplayDeleteButton = () => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const invitationDateParts = invitation.date.split('/');
    const invitationDate = new Date(
      '20' + invitationDateParts[2], // Assuming the year is 2020+
      parseInt(invitationDateParts[1]) - 1, // Month is zero-indexed
      invitationDateParts[0]
    );
    return (
      invitationDate.getTime() !== today.getTime() &&
      invitationDate.getTime() !== tomorrow.getTime()
    );
  };


  const handleCustomerNameChange = (event) => {
    console.log(invitation)
    const inputValue = event.target.value;
    const onlyLetters = /^[A-Za-zא-ת\s]*$/;

    if (onlyLetters.test(inputValue)) {
      invitation.name = event.target.value;
      setUpdateInvitation({ ...invitation, name: event.target.value });
    } else {
      alert("שם מכיל אותיות בלבד");
    }
  }

  const handleCustomerAmount = (event) => {
    invitation.amount = event.target.value;
    setUpdateInvitation({ ...invitation, amount: event.target.value });
  }

  const handleCustomerPhone = (event) => {
    const input = event.target.value;
    const phoneRegex = /^[0-9]*$/;
    if (phoneRegex.test(input)) {
      invitation.phone = event.target.value;
      setUpdateInvitation({ ...invitation, phone: event.target.value });
    } else {
      alert("  מספרים בלבד");
    }
  }

  // const handlePhoneChange = (event) => {
  //   const input = event.target.value;
  //   const phoneRegex = /^[0-9]*$/;
  //   if (phoneRegex.test(input)) {   
  //     setPassenger({ ...passenger, phone: input });
  //     event.target.value = input;
  //     passenger.phone = input;
  //     console.log(passenger);
  //     const updatedPassengers = invitation.passengers.map((passenger) => {
  //       if (passenger.connectedCustomerTravel === id) {
  //         return {
  //           ...passenger,
  //           phome: input,
  //         };
  //       }
  //       return passenger;
  //     });

  //     invitation.passengers = updatedPassengers;
  //   } else {
  //     alert("מספרים בלבד");
  //   }
  // }

  const handlePhoneChange = (event) => {
    console.log(updateInvitation)
    passenger.phone = event.target.value;
    setPassenger(passenger);
    const updatedPassengers = invitation.passengers.map((passenger) => {
      if (passenger.connectedCustomerTravel === id) {
        return {
          ...passenger,
          phone: event.target.value,
        };
      }
      return passenger;
    })
  }


  const handleNameChange = (event) => {
    console.log(updateInvitation)
    passenger.name = event.target.value;
    setPassenger(passenger);
    const updatedPassengers = invitation.passengers.map((passenger) => {
      if (passenger.connectedCustomerTravel === id) {
        return {
          ...passenger,
          name: event.target.value,
        };
      }
      return passenger;
    });


    setUpdateInvitation({
      ...invitation,
      passengers: updatedPassengers,
    });
  }

  return (
    <div>
      
      {showError && (
        <div style={{ 'textAlign': 'center' }}>
          <h1>404</h1>
          <p>הנסיעה נמחקה </p>
          <Link className='inviteLink' to='/Invite'>
            <button className='optionsBtn' variant="contained" color="primary">
              הזמן נסיעה
            </button>
          </Link>
        </div>
      )}

      {!showError && (
        <div>
          <div>
            {isLoading && (
              <div
                style={{
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 9999,
                  padding: '20px',
                  borderRadius: '8px',
                }}
              >
                <CircularProgress sx={{ color: '#3422F2' }} size={200} />
              </div>
            )}
          </div>
          {editMode ? (<div>
            <h4 className='titles'> עריכת הזמנה </h4>
          </div>) : (<div>
            {/* <h4 className='titles'> פרטי הנסיעה שלך</h4> */}
            <div>
              {showIframe && (
                <div id="iframeDiv" style={{ backgroundColor: '#f8f8ff', display: 'flex', justifyContent: 'center' }} >
                  <iframe style={{ width: '450px', marginTop: '20px', borderRadius: '10px' }} id="iframeContainer"></iframe>
                </div>
              )}
            </div>
          </div>)}

          {/* <div className='direction'>
            <span className="fieldLabel">סוג נסיעה: {'הצטרפות להסעה'}</span>
          </div> */}

          {approv ? (<div>
            <div className='direction'>
              <span className="fieldLabel"> מספר נסיעה: {invitation?.travelNumber}</span>
            </div>
            <div className='direction'>
              <span className="fieldLabel">שם: </span>
              {editMode ? (
                <input className="invitationInput" type="text" value={passenger?.name} onChange={handleNameChange} />
              ) : (
                <span>{passenger?.name}</span>
              )}
            </div>
            <div className='direction'>
              <span className="fieldLabel">כמות נסעים:</span>
              {editMode ? (
                <span>{passenger?.amountOfPassengers}</span>
                // <input className="invitationInput" type="text" value={passenger?.amountOfPassengers}  />
              ) : (
                <span>{passenger?.amountOfPassengers}</span>
              )}
            </div>
            <div className='direction'>
              <span className="fieldLabel">תאריך ושעה: </span>
              {/* {editMode ? (
            <div>
              <input className="invitationInput" type="text" value={invitation?.dateStartTraveling}  />
              <input className="invitationInput" type="time" value={invitation?.hourStartTraveling}  />
            </div>
          ) : ( */}
              <span>{invitation?.dateStartTraveling}, {invitation?.hourStartTraveling}</span>
              {/* )} */}
            </div>
            <div className='direction'>
              <span className="fieldLabel">טלפון: </span>
              {editMode ? (
                <input className="invitationInput" type="text" value={passenger?.phone} onChange={handlePhoneChange} />
              ) : (
                <span>{passenger?.phone}</span>
              )}
            </div>
            <div className='direction'>
              <span className="fieldLabel"> מסלול: </span>
              {editMode ? (
                // <FormControl sx={{ minWidth: 100, margin: '10px 0' }}>
                //   <InputLabel id="demo-simple-select-label"> מסלול</InputLabel>
                //   <Select
                //     labelId="demo-simple-select-label"
                //     id="demo-simple-select"
                //     label=" מסלול"
                //     value={orbitName}
                //     autoWidth
                //   >
                //     <MenuItem value="">
                //       <em></em>
                //     </MenuItem>
                //     {allOrbits?.map((orbit) =>
                //       <MenuItem key={orbit.id} value={orbit}>
                //         {orbit.name}
                //       </MenuItem>
                //     )}
                //   </Select>
                // </FormControl>
                <></>
              ) : (
                <span>{invitation?.orbit.name}</span>
              )}
            </div>
            <div className='direction'>
              <span className="fieldLabel"> חתימה: </span>
              <img src={passenger?.customerSignature} />
            </div>
          </div>

          ) : (<div>
           
               <div className="iphone-pro">
      <div className="div">
        <div className="overlap">
          <div className="text-wrapper">שם בעברית</div>
          {/* <div className="text-wrapper-2">שם באנגלית</div> */}
          <div className="text-wrapper-3">כמות נוסעים</div>
          <div className="text-wrapper-4">טלפון</div>
          <div className="text-wrapper-5">{invitation?.phone}</div>
          <div className="text-wrapper-6">{invitation?.englishName}</div>
          <div className="text-wrapper-7">{invitation?.amount}</div>
          <div className="text-wrapper-8" style={{left:'180px'}}>{invitation?.name}</div>
        </div>
        <div className="overlap-group">
          <div className="text-wrapper-9">מזהה נסיעה</div>
          <div className="text-wrapper-10">מזהה לקוח</div>
          <div className="text-wrapper-11"></div>
          <div className="text-wrapper-12">{invitation?.localID}</div>
        </div>
        <div className="vector-wrapper">
        <img style={{height : '100px' , width : '200px' , marginTop : '10px'}} src={invitation?.signature} />
        </div>
        <div className="overlap-2">
          <div className="overlap-3">
            <div className="text-wrapper-13">תאריך</div>
            <div className="text-wrapper-14">{invitation?.date}</div>
          </div>
          <div className="overlap-4">
            <div className="text-wrapper-15">שעה</div>
            <div className="text-wrapper-16">מסלול</div>
            <div className="text-wrapper-17">{invitation?.time}</div>
            <div className="text-wrapper-18">{invitation?.orbit.name}</div>
          </div>
          <div className="overlap-5">
            <div className="text-wrapper-19">מספר טיסה</div>
            <div className="text-wrapper-20">{invitation?.flightNumber}</div>
          </div>
        </div>
        {invitation?.travelBack ? <>
          <div className="overlap-group-2">
          <div className="overlap-6">
            <div className="text-wrapper-13">תאריך</div>
            <div className="text-wrapper-14">{invitation?.travelBack.date}</div>
          </div>
          <div className="text-wrapper-21">שעה</div>
          <div className="overlap-7">
            <div className="text-wrapper-22">מסלול</div>
            <div className="text-wrapper-23">{invitation?.travelBack.time}</div>
            <div className="text-wrapper-24">{invitation?.travelBack.orbit.name}</div>
          </div>
        </div>
        </> : <>
        <div className="overlap-group-2"></div>
        </>}
      
        <div className="text-wrapper-26">הלוך</div>
        <div className="text-wrapper-27">חתימה</div>
        <div className="text-wrapper-28">פרטי נוסע</div>
        <div className="text-wrapper-29">חזור</div>
        <div className="text-wrapper-30">פרטי הנסיעה שלך</div>
        <div className="text-wrapper-31">נסיעה טובה פאיכלה!</div>
      </div>
    </div>

            </div>
          )}

        </div>
      )}
    </div>
  )
}

export default EditSadir